'use client';

import React from 'react';
import clsx from 'clsx';
import { Button } from '@theme/components';

type TabItem = {
  slug: string;
  title: string;
};

type TabsProps = {
  tabs: TabItem[];
  activeTab: string;
  onChange: (slug: string) => void;
  className?: string;
};

const BlogTabs = ({ tabs, activeTab, onChange, className }: TabsProps) => {
  return (
    <div className={clsx('', className)}>
      <div className="flex items-center mx-auto">
        {tabs.map((tab) => {
          const isActive = activeTab === tab?.slug;

          return (
            <Button
              key={tab?.slug}
              appearance="outlined"
              className={`px-8 lg:px-11 h-16 text-base text-black-100 whitespace-nowrap bg-transparent hover:bg-transparent hover:underline hover:text-black-100 ${
                isActive ? 'underline font-bold' : ''
              }`}
              onClick={() => onChange(isActive ? '' : tab?.slug)}
            >
              {tab?.title}
            </Button>
          );
        })}
      </div>
    </div>
  );
};

export default BlogTabs;
